export default class {
  constructor(options){
      if(options){
          this.client = options.client
          this.organizationID = options.organizationID
      }
  }
  // mark ***
  fetch(options){
      return this.client.get(`/shifts`,{params: options})
  }
}


// WEBPACK FOOTER //
// ./lib/apiClient/organizations/shifts.js